/**
 * RelatedCreate — el "+" de cabecera de las tarjetas de Relacionados.
 * Estructura única entre pantallas (Contactos, Prospectos, Proyectos):
 * ícono plus ghost cyan a la derecha del título, tooltip = la acción.
 *
 * Dos modos, excluyentes:
 * - `to`: navega al módulo destino con su flujo de crear abierto y el
 *   cliente precargado (query params `nuevo=1&contactId=...`).
 * - `onClick`: dispara el flujo de crear en la misma pantalla (modal o
 *   selector inline), cuando el módulo lo resuelve in situ.
 */
import { useNavigate } from 'react-router-dom';
import { IconButton } from './IconButton.js';
import { Icon } from '../Icon.js';

interface RelatedCreateProps {
  label: string;
  to?: string;
  onClick?: () => void;
  disabled?: boolean;
}

export function RelatedCreate({ label, to, onClick, disabled }: RelatedCreateProps) {
  const navigate = useNavigate();
  return (
    <IconButton
      variant="ghost"
      tone="cyan"
      size="sm"
      icon={<Icon name="plus" size={14} />}
      ariaLabel={label}
      tooltip={label}
      disabled={disabled ?? false}
      onClick={() => {
        if (onClick) onClick();
        else if (to) navigate(to);
      }}
    />
  );
}
